/** Narrowing helpers for the page's own markup: a missing or mistyped element is a build error, not a silent no-op. */
export function element<T extends HTMLElement>(
  id: string,
  kind: new () => T,
): T {
  const node = document.getElementById(id);
  if (!(node instanceof kind)) {
    throw new Error(`Expected #${id} to be a ${kind.name}`);
  }
  return node;
}

export function elements<T extends Element>(
  root: ParentNode,
  selector: string,
  kind: new () => T,
): T[] {
  return [...root.querySelectorAll(selector)].filter(
    (node): node is T => node instanceof kind,
  );
}

export function control<T extends Element>(
  form: HTMLFormElement,
  name: string,
  kind: new () => T,
): T {
  const node = form.elements.namedItem(name);
  if (!(node instanceof kind)) {
    throw new Error(`Expected form control "${name}" to be a ${kind.name}`);
  }
  return node;
}

export function prefersReducedMotion(): boolean {
  return matchMedia("(prefers-reduced-motion: reduce)").matches;
}
